import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type RowVariant = "total" | "item";

type Props = {
	variant: RowVariant;
	label: string;
	amount: number;
	icon?: ReactNode;
	amountColor?: string;
	isLast?: boolean;
};

export const BalanceBreakdownRow: FC<Props> = ({
	variant,
	label,
	amount,
	icon,
	amountColor,
	isLast = false,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const isTotal = variant === "total";
	const resolvedAmountColor =
		amountColor ?? (isTotal ? undefined : theme.palette.grey[700]);

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			gap={theme.spacingTokens.sm}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			borderBottom={isLast ? "none" : theme.colors.border.flatRowDivider}
		>
			<Stack direction="row" alignItems="center" gap={theme.spacingTokens.sm}>
				{icon}
				<Typography variant={isTotal ? "bodyMedium" : "body2"}>
					{label}
				</Typography>
			</Stack>
			<Typography
				variant={isTotal ? "bodyStrong" : "body2"}
				color={resolvedAmountColor}
				tabular
			>
				{moneyFormatter(amount, t(Resources.Common.CurrencySign))}
			</Typography>
		</Stack>
	);
};
